import Vue from 'vue'
import Vuex from 'vuex'
import App from './App.vue'
import router from './router'
import { LayoutPlugin } from 'bootstrap-vue'
import {state, actions, mutations, getters} from './store/index'

Vue.use(Vuex)
Vue.use(LayoutPlugin)

// import BootstrapVue from 'bootstrap-vue'
// Vue.use(BootstrapVue)

Vue.config.productionTip = false

const store = new Vuex.Store({
  state,
  actions,
  mutations,
  getters
})

new Vue({
  store,
  router, 
  render: h => h(App),
}).$mount('#app')
